"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var LineChartIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(LineChartIcon, _React$PureComponent);

  function LineChartIcon() {
    _classCallCheck(this, LineChartIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(LineChartIcon).apply(this, arguments));
  }

  _createClass(LineChartIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'line-chart-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M0.72,0 C1.117,0 1.44,0.323 1.44,0.72 L1.44,0.72 L1.44,10.56 L11.28,10.56 C11.677,10.56 12,10.883 12,11.28 C12,11.677 11.677,12 11.28,12 L11.28,12 L0,12 L0,0.72 C0,0.323 0.323,0 0.72,0 Z M11.0824985,2.00959084 C11.2924985,1.97659084 11.5024985,2.02859084 11.6734985,2.15459084 C12.0264985,2.41359084 12.1024985,2.91159084 11.8434985,3.26559084 L11.8434985,3.26559084 L8.79749845,7.41459084 L8.79749845,7.41459084 C8.64049845,7.62859084 8.39949845,7.74059084 8.15349845,7.74059084 C7.99049845,7.74059084 7.82749845,7.69059084 7.68549845,7.58759084 L7.68549845,7.58759084 L6.25049845,6.53359084 L4.43549845,9.00659084 C4.31049845,9.17759084 4.12549845,9.28959084 3.91549845,9.32159084 C3.87449845,9.32859084 3.83349845,9.33159084 3.79349845,9.33159084 C3.62549845,9.33159084 3.46249845,9.27859084 3.32449845,9.17659084 C3.15349845,9.05159084 3.04149845,8.86659084 3.00949845,8.65659084 C2.97649845,8.44759084 3.02849845,8.23759084 3.15349845,8.06659084 L3.15349845,8.06659084 L5.43849845,4.95459084 C5.43849845,4.95359084 5.43849845,4.95359084 5.43949845,4.95259084 C5.47349845,4.90559084 5.52049845,4.87759084 5.56249845,4.84059084 C5.75749845,4.66859084 6.01549845,4.59259084 6.26349845,4.65059084 C6.36449845,4.67459084 6.46149845,4.71759084 6.54949845,4.78159084 C6.55049845,4.78159084 6.55049845,4.78259084 6.55149845,4.78259084 L6.55149845,4.78259084 L7.98549845,5.83559084 L10.5624985,2.32459084 C10.6874985,2.15459084 10.8724985,2.04159084 11.0824985,2.00959084 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return LineChartIcon;
}(_react.default.PureComponent);

exports.default = LineChartIcon;
LineChartIcon.defaultProps = {
  color: 'inherit'
};
LineChartIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};